import { Component, Input, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { QuantidadeCTeStruct } from '../../../../shared/services/structs/repo-dfe/quantidade-cte.struct';
import { DetalheCTeRecebidoResponse } from '../../../../shared/services/responses/repo-dfe/detalhe-cte-recebido.response';
import { StatusDocumentoEnum } from '../../../../shared/enums/dfe/status-documento.enum';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { DisponibilidadeDocumentoSefazEnum } from '../../../../shared/enums/dfe/disponibilidade-documento-sefaz.enum';

@Component({
    selector: 'app-cte-detalhe',
    standalone: true,
    imports: [CommonModule, RouterModule, MatIconModule, MatButtonModule, CurrencyPipe, DatePipe, MatTableModule],
    templateUrl: './cte-detalhe.component.html',
    styleUrls: ['./cte-detalhe.component.css']
})
export class CTeDetalheComponent implements OnInit {
    @Input() notaDetalhe!: DetalheCTeRecebidoResponse;

    public _isCancelamento: boolean = false;

    // Configurações da tabela de quantidades de carga
    public displayedColumnsCarga: string[] = ['unidade', 'tipoMedida', 'quantidade'];
    public dataSourceCarga = new MatTableDataSource<QuantidadeCTeStruct>();

    constructor(private router: Router) { }

    ngOnInit(): void {
        this._isCancelamento = this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Cancelado;
        if (this.notaDetalhe.dadosCTe?.quantidades) {
            this.dataSourceCarga.data = this.notaDetalhe.dadosCTe.quantidades;
        }
    }

    voltar() {
        this.router.navigate(['/notas-fiscais/notas-recebidas/']);
    }

    public obterDescricaoSituacaoDocumento(): string {
        if (this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Cancelado) return 'Cancelado';
        if (this.notaDetalhe.resumo.descricaoSituacaoDocumento) return this.notaDetalhe.resumo.descricaoSituacaoDocumento;

        switch (this.notaDetalhe.resumo.idDisponibilidadeDocumentoSefaz) {
            case DisponibilidadeDocumentoSefazEnum.DocumentoCompleto: return 'Documento completo';
            case DisponibilidadeDocumentoSefazEnum.ResumoRecebido: return 'Resumo recebido';
            case DisponibilidadeDocumentoSefazEnum.Identificado: return 'Identificado';
            default: return this.notaDetalhe.resumo.idStatusDocumento === StatusDocumentoEnum.Autorizado ? 'Autorizado' : 'Situação não identificada';
        }
    }
}
